import { useEffect, useState } from "react";
import CardInformacaoAssinatura from "./cardInformacaoAssinatura";
import Functions from "../../../../callable/functions";
import { Box, Typography } from "@mui/material";
import { Skeleton } from "@mui/material";
import { IconCreditCard } from "@tabler/icons-react";
import MetodoDePagamento from "../../../../models/metodoDePagamento";
import { LoadingButton } from "@mui/lab";
import { useSnackBar } from "../../../../stores/snackBarStores";

export default function CardMetodoDePagamento() {
  const [metodoPagamento, setMetodoPagamento] = useState<MetodoDePagamento>();
  const snackBar = useSnackBar();
  const [loading, setLoading] = useState(false);

  const redirecionarParaPortalDoCliente = async () => {
    setLoading(true);
    new Functions()
      .obterLinkPainelDoCliente({ returnUrl: window.location.href })
      .then(({ data }) => {
        snackBar({
          type: "ALERT",
          payload: {
            mensagem:
              "Gerencie seu método de pagamento pelo Portal do Cliente que foi aberto numa nova aba.",
            severidade: "info",
          },
        });
        window.open(data.url, "_newtab");
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    new Functions()
      .obterMetodoDePagamento()
      .then((result) =>
        setMetodoPagamento(MetodoDePagamento.fromJson(result.data[0]))
      )
      .catch((error) => console.error(error));
  }, []);

  return (
    <CardInformacaoAssinatura
      titulo="Método de pagamento"
      Icone={IconCreditCard}
      conteudo={
        metodoPagamento
          ? "Método de pagamento cadastrado:"
          : "Cadastre um método de pagamento."
      }
      destaque={
        metodoPagamento ? (
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <IconCreditCard size={20} />
            <Typography variant="dataMono" fontSize={16} letterSpacing="0.06em">
              {"•••• •••• •••• "}
              {metodoPagamento.ultimos4Numeros}
            </Typography>
          </Box>
        ) : (
          <Skeleton variant="text" animation={false} />
        )
      }
      rodape={
        <LoadingButton
          variant="text"
          loading={loading}
          onClick={redirecionarParaPortalDoCliente}
          sx={{ color: "accentInk" }}
        >
          Atualizar ou cancelar assinatura
        </LoadingButton>
      }
    />
  );
}
